import {Component, Input, OnInit} from '@angular/core';
import {Album} from "../../../api-client/model/Album";
import {HosPlayAlbum, HosPlayItem} from "../../../services/player/hos-play-item";
import {HosPlayerService} from "../../../services/player/hos-player.service";
import {HosQueueSingleAlbum} from "../../../services/player/hos-queue";
import {Track} from "../../../api-client/model/Track";
import {AlertsUtilService} from "../../../services/alerts-util.service";
import {LoggedUserBlockedItemsService} from "../../../services/logged-user-blocked-items.service";
import {MixpanelService} from "../../../services/mixpanel.service";
import {TrackingUtils} from '../../utils/tracking.utils';
import {Router} from '@angular/router';
import {StopTimerService} from '../../../services/stop-timer.service';
import {PlayButtonIconSize} from '../../../app.constants';

@Component({
  selector: 'app-play-album-track-button',
  templateUrl: './play-album-track-button.component.html',
  styleUrls: ['./play-album-track-button.component.scss']
})
export class PlayAlbumTrackButtonComponent implements OnInit {
  @Input() iconSize : PlayButtonIconSize;
  @Input() album: Album;
  @Input() track: Track;
  @Input() extraClasses: string = "";
  @Input() enabled: boolean = true;

  playButtonIconSize = PlayButtonIconSize;

  public playItem: HosPlayItem;

  constructor(public hosPlayerService: HosPlayerService,
              private loggedUserBlockedItemsService: LoggedUserBlockedItemsService,
              private alertsUtilService: AlertsUtilService,
              private stopTimerService: StopTimerService) {
  }

  ngOnInit() {
    if (this.album) {
      this.playItem = new HosPlayAlbum(this.album);
    }
  }

  playPauseTrack() {
    this.stopTimerService.reset();
    if (this.enabled) {
      if (!this.loggedUserBlockedItemsService.isBlocked(this.track)) {
        this.hosPlayerService.play(new HosQueueSingleAlbum(this.album), this.track);
      } else {
        this.alertsUtilService.showAlert("The item is blocked, please unblock it and try again");
      }
    } else {
      this.alertsUtilService.showAlertError("ALBUM_UNPLAYABLE");
    }
  }
}
